module.exports = __webpack_public_path__ + "static/media/swiftly.d5ceca98.mp3";